goog.provide("shadow.js.shim.module$src$svg$arrows$arrow_down_to_line_svg$default");
shadow.js.shim.module$src$svg$arrows$arrow_down_to_line_svg$default = shadow.js.shim.module$src$svg$arrows$arrow_down_to_line_svg.default;
